export const createRejectOrApproveFailureMessage = (type, options = {}) => {
  const { multiple } = options;
  return `Hash ID${multiple ? 's' : ''} could not be ${type}. Try again.`;
};
